// Per-env API base for the CashRev /designations endpoint.
//
// The existing pages (webhook.js / FileUploader.js) hardcode execute-api URLs
// via REACT_APP_* build-time envs. We follow that convention but resolve by
// hostname so it stays correct even if a branch env var is unset:
//   staging.<appId>.amplifyapp.com -> staging API
//   everything else (main/prod)    -> main API
// localhost defaults to STAGING so a local build can never write prod.
const API_BY_ENV = {
  staging: 'https://ji4o4qhdob.execute-api.us-east-2.amazonaws.com/Prod',
  main: 'https://jwc7v9ozxg.execute-api.us-east-2.amazonaws.com/Prod',
};

export function getApiBase() {
  if (process.env.REACT_APP_DESIGNATIONS_API_URL) {
    return process.env.REACT_APP_DESIGNATIONS_API_URL;
  }
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (host.startsWith('staging') || host === 'localhost' || host.startsWith('127.')) {
    return API_BY_ENV.staging;
  }
  return API_BY_ENV.main; // main / prod default
}

export function getDesignationsUrl() {
  return `${getApiBase()}/designations`;
}
